<template>
  <router-view> </router-view>
</template>

<script>
export default {
  name: "content1"
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/index/content/content1.vue